import React, { useEffect } from 'react';
import styles from './index.module.scss';

const AgeVerificationScreen = ({ handleConfirm, handleDecline }) => {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <p className={styles.text}>
          Сайт містить контент тільки для користувачів, які досягли повноліття
        </p>
        <p className={styles.question}>
          Чи досягли
          <br />
          ви повноліття?
        </p>
        <div className={styles.buttons}>
          <button
            type="button"
            className={styles.button}
            onClick={handleConfirm}
          >
            Так
          </button>
          <button
            type="button"
            className={styles.button}
            onClick={handleDecline}
          >
            Ні
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeVerificationScreen;
